import { ConnectionType } from '@accedo/ctv-device-api';

export enum EventType {
  LOAD = 'LOAD',
  BEGIN = 'BEGIN',
  PROGRESS = 'PROGRESS',
  COMPLETE = 'COMPLETE',
  AD_BEGIN = 'AD_BEGIN',
  AD_COMPLETE = 'AD_COMPLETE',
}

export type MediaType = 'vod' | 'live';
export type PluginType = 'javascript' | 'native';

export interface Event {
  timestamp: string;
  event: EventType;
  fromPosition?: number;
  toPosition?: number;
}

export interface Properties {
  programId?: string;
  programName: string;

  seriesId: string;
  seriesName: string;

  episodeId?: string;
  episodeName?: string;

  channel: string;

  deviceId?: string; // This value is not expected if user permissions are not provided/ Ad tracking is restricted.

  connectionType: ConnectionType | '';
  streamingType?: 'AirPlay' | 'Chromecast' | string;

  latitude?: number;
  longitude?: number;

  classification?: string;
  genre?: string;
  altMediaId?: string;
  originMediaId?: string;
  dvbTriplet?: string;
  postCode?: string;

  demo1: string;
  demo2?: string;
  demo3?: string;
}

export interface UserAgent {
  browser?: string;
  os?: string;
  platform?: string;
  version?: string;
  deviceType?: string;
}

export interface MeterEvent {
  protocolVersion: string;
  plugin: PluginType;
  mediaType: MediaType;
  vendorVersion: string;
  timestamp: string;
  timezoneOffset: number;
  sessionId: string;
  ipAddress: string;
  publisherId: string;
  mediaId: string;
  url?: string;
  mediaDuration?: number;
  events: Event[];
  properties?: Properties; // required only for BEGIN event
  userAgent?: UserAgent;
}

export interface VideoData {
  mediaType: MediaType;
  publisherId: string;
  mediaId: string;
  mediaDuration?: number;
  programId?: string;
  programName: string;
  seriesId: string;
  seriesName: string;
  episodeId?: string;
  episodeName?: string;
  channel: string;
  classification?: string;
  genre?: string;
  altMediaId?: string;
  originMediaId?: string;
}
